import styled from "styled-components";
import {Variant} from "./index";

export const Button = styled.button<{variant?: Variant}>`
  position: relative;
  background-color: ${({variant}) => variant === Variant.Business ? '#00637BCC' : variant === Variant.Outline_Business ? '#FFFFFF00' : '#B3376CCC'};
  border-radius: 40px;
  border: ${({variant}) => variant === Variant.Outline_Business ? '2px solid #00637BCC' : 'none'};
  padding: 15px 15px;
  color: ${({variant}) => variant === Variant.Outline_Business ? '#00637BCC' : '#fff'};
  font-family: ${({theme}) => theme.font.family};
  font-style: normal;
  font-size: 16px;
  line-height: 19px;
  font-weight: 400;
  cursor: pointer;
  
  &:hover {
    background-color: ${({variant}) => variant === Variant.Business ? '#00637B' : variant === Variant.Outline_Business ? '#00637B' : '#B3376C'};
    color: #fff;
  }
  
  &:disabled {
    cursor: not-allowed;
    opacity: 80%;
  }

  @media only screen and (${({theme}) => theme.media.small}) {
    font-size: 16px;
    font-weight: 400;
    line-height: 19px;
    padding: 15px 30px;
  }

  @media only screen and (${({theme}) => theme.media.extraLarge}) {
    font-size: 18px;
    line-height: 26px;
  }

  @media only screen and (${({theme}) => theme.media.ultraLarge}) {
    font-size: 20px;
    line-height: 28px;
  }

  @media only screen and (min-width: 1600px) {
    font-size: 24px;
    line-height: 33px;
  }
`